export const TRANSACTION_REQUESTED = "Requested";
export const TRANSACTION_PAID = "Paid";
export const TRANSACTION_CANCELLED = "Cancelled";
export const TRANSACTION_REQ_APPROVAL = "Awaiting Approval";
export const TRANSACTION_UNKNOWN = "Unknown";
export const TRANSACTION_STATE_MAPPING = [{
  state: TRANSACTION_REQ_APPROVAL,
  description: "Transaction submitted to system awaiting payment approval"
}, {
  state: TRANSACTION_REQUESTED,
  description: "Transaction submitted to system awaiting payment"
}, {
  state: TRANSACTION_PAID,
  description: "Transaction payment complete"
}, {
  state: TRANSACTION_CANCELLED,
  description: "Transaction payment cancelled"
}, {
  state: TRANSACTION_UNKNOWN,
  description: "State of this transaction is not known, please submit support ticket with transaction ID"
}];
export const registerTransactionState = state => {
  if (state === "requested") {
    return TRANSACTION_REQUESTED;
  }
  if (state === "paid") {
    return TRANSACTION_PAID;
  }
  if (state === "cancelled") {
    return TRANSACTION_CANCELLED;
  }
  if (state === "req_approval") {
    return TRANSACTION_REQ_APPROVAL;
  }
  return TRANSACTION_UNKNOWN;
};